export default {
  FETCH_POWERBI_CONFIG: 'FETCH_POWERBI_CONFIG',
  FETCH_POWERBI_CONFIG_SUCCESS: 'FETCH_POWERBI_CONFIG_SUCCESS',
  POWERBI_REFRESH_SESSION: 'POWERBI_REFRESH_SESSION'
}
